import React, { useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'
import { usePopper } from 'react-popper'

import useOnClickOutside from '../../common/hooks/useOnClickOutside'
import { WidgetDropdownFilterOptions } from '../widget-dropdown-filter-options'
import { WidgetDropdownFilterSearch } from '../widget-dropdown-filter-search'
import { LogTypes } from '../../common/constants/LogTypes'

export type WidgetDropdownFilterPopupProps = {
    options: Array<LogTypes>
    defaultOptions: Array<LogTypes>
    onChange: (options: Array<LogTypes>) => void
    onClose: () => void
    className?: ClassName
    style?: React.CSSProperties
    filterButtonRef: React.MutableRefObject<HTMLButtonElement | null>
}

const Container = styled.div`
    width: 255px;
    max-height: 265px;
    border: 1px solid #dddddd;
    background: #ffffff;
    z-index: 2;
    overflow: scroll;
    content-visibility: auto;
`
const SMainContainer = styled.div`
    position: relative;
    z-index: 99;
`

const SearchWrapper = styled.div`
    padding: 8px;
    background-color: #ffff;
    position: relative;
    top: 0;
    z-index: 1;
    border: 1px solid #dddd;
    border-bottom: none;
    padding: 8px;
`

export function WidgetDropdownFilterPopup({
    className,
    style,
    options,
    defaultOptions,
    onChange,
    onClose,
    filterButtonRef,
}: WidgetDropdownFilterPopupProps): React.ReactElement {
    const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null)

    const { attributes, styles } = usePopper(filterButtonRef.current, popperElement, {
        placement: 'bottom-end',
    })

    useOnClickOutside({ current: popperElement }, onClose)
    const [visibleOptions, setVisibleOptions] = useState<Array<LogTypes>>([])
    return (
        <SMainContainer
            className={cn(className)}
            ref={setPopperElement}
            style={{ ...style, ...styles.popper }}
            {...attributes.popper}
            data-testid="WidgetDropdownFilterPopup"
        >
            <SearchWrapper>
                <WidgetDropdownFilterSearch
                    setVisibleOptions={setVisibleOptions}
                    visibleOptions={visibleOptions}
                    defaultOptions={defaultOptions}
                />
            </SearchWrapper>
            <Container>
                <WidgetDropdownFilterOptions
                    onChange={onChange}
                    options={options}
                    visibleOptions={visibleOptions}
                    defaultOptions={defaultOptions}
                />
            </Container>
        </SMainContainer>
    )
}
